export const HOUSEKIOSK_BASE = '/housekiosk';

export const houseKioskRoutes = {
  base: HOUSEKIOSK_BASE,
  login: `${HOUSEKIOSK_BASE}/login`,
  teacher: `${HOUSEKIOSK_BASE}/teacher`,
  mascot: (houseId?: string) => (houseId ? `${HOUSEKIOSK_BASE}/mascot/${houseId}` : `${HOUSEKIOSK_BASE}/mascot`),
  kiosk: `${HOUSEKIOSK_BASE}/kiosk`,
  leaderboard: `${HOUSEKIOSK_BASE}/leaderboard`,
};
